export const ROUTE_UPDATE_LIST="ROUTE_UPDATE_LIST"
export const ROUTE_UPDATE_LIST_SUCCESS="ROUTE_UPDATE_LIST_SUCCESS"

export const POST_ROUTE_UPDATE="POST_ROUTE_UPDATE"
export const POST_ROUTE_UPDATE_SUCCESS="POST_ROUTE_UPDATE_SUCCESS"

export const ROUTE_UPDATE_API_ERROR_ACTION="ROUTE_UPDATE_API_ERROR_ACTION"

